export const LOADING = "LOADING";

export const isLoading = isLoading => ({
    type: LOADING,
    isLoading
})